import { SxProps } from '@mui/material';

export const iconContainer: SxProps = {
  pl: 0,
  ':hover': {
    backgroundColor: 'transparent'
  }
};

export const workflowIconButtonSx: SxProps = {
  ml: 0.5,
  p: 0.5
};

export const workflowTooltipSx = {
  backgroundColor: 'customGrey.dark',
  color: 'common.white',
  fontSize: '14px',
  borderRadius: '16px',
  px: '12px',
  py: '4px',
  maxWidth: 250
};

export const workflowTooltipArrowSx = {
  color: 'customGrey.dark'
};
